import React from 'react';
import Layout from '../../components/Layout';
import HeadMessage from '../../components/Common/HeadMessage/HeadMessage';
import Support from './Support';

async function action() {
	return {
		title: 'Support & Feature Requests',
		description:
			'Get help with New Tab Studio: email us about payments, PRO and partnerships, or send a bug report and a feature request through the idea hub.',
		chunks: ['support'],
		component: (
			<Layout>
				<HeadMessage>
					<h1>
						<span>Support</span>
					</h1>
				</HeadMessage>

				<Support />
			</Layout>
		),
	};
}

export default action;
